module.exports = __webpack_public_path__ + "img/prize-3.d14d8808.png";